import { ApolloLink } from '@apollo/client';
import { uploadAuth } from '@frameio/utils/auth';

/**
 * Adds the upload-auth header when a visitor is requesting data from the public
 * `/upload/:uploadLinkId` experience.
 *
 * The upload link id is always set; passphrases are only present once the
 * visitor has entered one (a later step) and the backend requires it.
 */
export const uploadAuthLink = (uploadLinkId: string) => {
  return new ApolloLink((operation, forward) => {
    const passphrase = uploadAuth.getPassphraseById(uploadLinkId);

    operation?.setContext({
      headers: {
        ...operation?.getContext()?.headers,
        [`${uploadAuth.X_UPLOAD_AUTHORIZATION_HEADER}`]:
          uploadAuth.encodeHeaderStringBase64(uploadLinkId, passphrase),
      },
    });

    return forward(operation);
  });
};
